var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaddingT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50977 3.40194C3.55651 3.16823 3.76172 3 4.00006 3H16.0001C16.2384 3 16.4436 3.16823 16.4904 3.40194L16.9904 5.90194C17.0395 6.14757 16.8993 6.39164 16.6623 6.47294C16.4255 6.5542 16.1651 6.44773 16.053 6.22385L16.0521 6.22217C15.8858 5.90189 15.6735 5.60038 15.4363 5.32925C15.0249 4.85913 14.5268 4.5 14.0001 4.5H11.5V15H12.5C12.7761 15 13 15.2239 13 15.5C13 15.7761 12.7761 16 12.5 16H11.5H8.5H7.5C7.22386 16 7 15.7761 7 15.5C7 15.2239 7.22386 15 7.5 15H8.5V4.5H6.00006C5.47328 4.5 4.97521 4.85913 4.56385 5.32925C4.32661 5.60039 4.11436 5.90189 3.94802 6.22217L3.94716 6.22385C3.83507 6.44773 3.57464 6.5542 3.33779 6.47294C3.10086 6.39164 2.96065 6.14757 3.00977 5.90194L3.50977 3.40194Z",
    fill: "#4040D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaddingT);
export default __webpack_public_path__ + "static/media/icon-padding-t.f1e9a4f467663707839d59ee7f27c88d.svg";
export { ForwardRef as ReactComponent };